import { mediaQuery } from 'constants/ui';

export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  boxShadow: ({ palette }) => palette.shadow.m,
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '0px 4px 4px 4px',
  overflow: 'hidden',
};

export const titleStyles = {
  padding: '20px 24px',
  fontSize: '2rem',
  lineHeight: '2.8rem',
  fontWeight: 700,
};

export const dividerStyles = {
  borderColor: ({ palette }) => palette.border.default,
};

export const contentStyles = {
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  alignItems: 'center',
  flex: 1,
  overflow: 'hidden',
};

export const contentWrapperStyles = {
  position: 'relative',
  flex: 1,
  minWidth: 0,
  alignSelf: 'flex-start',
  height: '100%',
  overflow: 'hidden',
  [mediaQuery.mobileAndTablet]: {
    width: '100%',
  },
};

export const controlsWrapperStyles = {
  display: 'flex',
  padding: '16px 24px',
  justifyContent: 'end',
  gap: '8px',
};

export const navigationStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  width: '240px',
  minWidth: '200px',
  flexShrink: 0,
  height: '100%',
  padding: '12px',

  '& .tabs': {
    flex: '1',
  },
};

export const mobileNavigationStyles = {
  padding: '12px 16px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
};
